import './App.css';
import './css/style.css'
import './css/responsive.css'
import './js/style.js'
import Dashboard from './components/Dashboard';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ActiveJobs from './components/jobs/ActiveJobs.js';
import ReceivedAplication from './components/ReceivedAplication.js';
import Login from './components/Login.js';
import UserDashboard from './components/UserDashboard.js';
import JobDetails from './components/JobDetails.js';
import PrivateRoutes from './PrivateRoutes.js';
import Notfound from './components/Notfound.js';

function App() {
  return (
    <div className="App">
      <BrowserRouter basename='/career'>
        <Routes>
          <Route element={<PrivateRoutes/>}>
              <Route path='/active-jobs' element={<ActiveJobs/>}/>
              <Route path='/admin-dashboard' element={<Dashboard/>}/>
              <Route path='/received-aplication' element={<ReceivedAplication/>}/>
          </Route>
          <Route path='/login' element={<Login/>}/>
          <Route path='/' element={<UserDashboard/>}/>
          <Route path='/job-details' element={<JobDetails/>}/>
          <Route path='*' element={<Notfound/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
